import React, { useEffect } from "react"
import { StyleProp, TextStyle, TouchableOpacity } from "react-native"
import { observer } from "mobx-react-lite"
import { flatten } from "ramda"
import * as WebBrowser from "expo-web-browser"
import * as Facebook from "expo-auth-session/providers/facebook"
import * as AuthSession from "expo-auth-session"

import { FontAwesome } from "@expo/vector-icons"

import { color } from "@app/theme"
import { Button, Text } from "@app/components"
import { viewPresets, textPresets } from "@app/components/button/button.presets"
import { UserSnapshot, useStores } from "@app/models"

import { FACEBOOK_APP_ID } from "@app/config/env"
WebBrowser.maybeCompleteAuthSession()

export interface FacebookAuthButtonProps {
  onAuthenticated: (user: UserSnapshot | null) => void
  text?: string
  style?: StyleProp<TextStyle>
  disabled?: boolean
  shouldAuth?: () => boolean
}
export const FacebookAuthButton = observer((props: FacebookAuthButtonProps) => {
  const [request, response, promptAsync] = Facebook.useAuthRequest({
    clientId: FACEBOOK_APP_ID,
    responseType: AuthSession.ResponseType.Token
  })

  const { userOauthConnect } = useStores()

  useEffect(() => {
    if (response?.type === "success") {
      const { params } = response
      const { code, access_token: accessToken } = params
      userOauthConnect({
        provider: "facebook",
        query: {
          ...(code && { code }),
          ...(accessToken && { accessToken })
        }
      }).then(props.onAuthenticated)
    }
  }, [response])

  const onPress = () => {
    const { shouldAuth = () => true } = props
    if (!shouldAuth()) return
    promptAsync()
  }

  return (
    <TouchableOpacity>
      <Button
        style={flatten([viewPresets.wide, BUTTON, props.style]) as TextStyle}
        disabled={props.disabled || !request}
        // name="facebook"
        // backgroundColor=""
        onPress={onPress}
      >
        <FontAwesome style={BUTTON_ICON} name="facebook" />
        <Text style={flatten([textPresets.wide, TEXT])}>{props.text || "Login med Facebook"}</Text>
      </Button>
    </TouchableOpacity>
  )
})

const BUTTON: TextStyle = {}

const BUTTON_ICON: TextStyle = {
  color: color.textWhite,
  padding: 5,
  paddingBottom: 4,
  fontSize: 18
}

const TEXT: TextStyle = {
  fontFamily: "Poppins-Bold",
  fontSize: 16,
  fontWeight: "900",
  color: color.textWhite
}
